import axios from 'axios'
import { BASE_URL } from './../utils/constant'
import { store } from './../shared/redux/store'
import { logout } from './../shared/redux/userSlice'
export const HTTP_Request = axios.create({
  baseURL: BASE_URL,
})

HTTP_Request.interceptors.request.use(
  (config) => {
    const { user } = store.getState().root.user
    if (user?.token) {
      config.headers.Authorization = `Bearer ${user.token}`
    }
    return config
  },
  (err) => Promise.reject(err),
)

// Auth bootstrap: if the backend rejects the token (expired/invalid), drop the
// session so the route guard falls back to the login screen instead of leaving
// a half-broken admin shell open. Only acts when we currently think we're logged
// in, so it can't loop. (Login itself uses raw axios, so login 401s are unaffected.)
HTTP_Request.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      const slice = store.getState()?.root?.user
      if (slice?.user) {
        store.dispatch(logout())
      }
    }
    return Promise.reject(err)
  },
)

export const initialConfig = (user) => {
  // setupAxios(user);
}
